/* eslint-disable global-require */
module.exports = ['marketplace.free.show.contact.m2', 'marketplace.free.show.contact.m7', 'footer.marketplace_legals'];
